import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import GameConfig from "../model/GameConfig";

export default class GameElementSkinFactory {

    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} assets 
     */
    constructor(gameConfig, levelAssets) {
        this._gameConfig = gameConfig;
        this._assets = levelAssets;

        this._cache = {};
    }

    clearCache() {
        this._cache = {};
    }

    getItem(index) {
        const skinName = this._gameConfig.getItemName(index);
        return new this._assets[skinName]();
    }

    getLocation(index, cache = true) {
        const skinName = this._gameConfig.getLocationSkin(index);
        if (cache && this._cache[skinName] != null) {
            const skin = this._cache[skinName];
            skin.x = 0;
            skin.y = 0;
            return skin;
        }

        const locationSkin = new this._assets[skinName]();
        locationSkin.gotoAndStop(0);//to populate children array
        if (cache) {
            for (let i = 1; i < 99; i++) {
                const layerSkin = locationSkin["layer" + i];
                if (!layerSkin) {
                    break;
                }
                CacheUtil.cache(layerSkin);
                layerSkin.removeAllChildren();
            }
            this._cache[skinName] = locationSkin;
        }
        return locationSkin;
    }

    getLocationBounds(index) {
        const loc = this._gameConfig.getLocation(index);
        return new createjs.Rectangle(0, 0, loc.width, loc.height);
    }

}